import React from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  Button,
  Row,
  Col,
  DatePicker,
  InputNumber,
  Input,
  message,
  Select,
  Avatar,
} from 'antd'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import slug from 'constants/slug'
import { autobind } from 'core-decorators'
import Breadcrumb from '../breadcrumb'
import createLanguage, { langPropTypes } from 'hoc/create-lang'
import OrganizationApi from 'api/OrganizationApi'
import moment from 'moment'
import UserApi from 'api/UserApi'
import createManagerList from 'hoc/manager-list'
import styled from 'styled-components'
import _ from 'lodash'
import {replaceVietnameseStr} from "utils/string"

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`

const TextAvatar = styled.span`
  margin-left: 10px;
  font-size: 15px;
`

const FormItem = Form.Item
const Option = Select.Option

const numberOfExpirationDates = [
  {
    value: 5,
    label: 'organization.package.numberOfExpirationDate.fiveDates',
  },
  {
    value: 10,
    label: 'organization.package.numberOfExpirationDate.tenDates',
  },
  {
    value: 15,
    label: 'organization.package.numberOfExpirationDate.fifteenDates',
  },
  {
    value: 20,
    label: 'organization.package.numberOfExpirationDate.twiceDates',
  },
]
@createManagerList({
  apiList: UserApi.getUsers,
  itemPerPage: 9999,
})
@Form.create()
@createLanguage
@autobind
export default class OrganizationPackage extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    lang: langPropTypes,
    initialValues: PropTypes.object,
  }
  state = {
    isLoaded: false,
  }
  async componentWillMount() {
    const key = this.props.match.params.key
    const res = await OrganizationApi.getOne(key)
    let packageInfo = {}
    if (res.success)
      packageInfo = res.data.packageInfo ? res.data.packageInfo : {}
    this.setState({
      packageInfo: {
        ...packageInfo,
        // expiredAt: packageInfo.expiredAt ? new Date(packageInfo.expiredAt) : "",
      },
      isLoaded: true,
      nameOrganization: res.data.name,
    })
  }

  _isOnPremisesOrganization() {
    if (
      this.state.packageInfo &&
      this.state.packageInfo.organizationType &&
      this.state.packageInfo.organizationType === 'ON_PREMISES'
    ) {
      return true
    }

    return false
  }

  async handleSubmit(e) {
    e.preventDefault()
    const key = this.props.match.params.key
    this.props.form.validateFields((err, values) => {
      if (err) return

      const userSelected = this.props.dataSource.find(
        (user) => user._id === values.directSeller
      )
      const salerInfo = this._getSalerInfo(userSelected._id)
      // console.log(salerInfo, 'salerInfosalerInfo')
      const contractExpiredDate = values.contractExpiredDate
      const data = {
        packageInfo: {
          totalUser: values.totalUser,
          totalStation: values.totalStation,
          contractStatus: values.contractStatus,
          contractId: values.contractId,
          contractSignDate: values.contractSignDate.format(
            'YYYY-MM-DD HH:mm:ss'
          ),
          contractExpiredDate: contractExpiredDate
            ? contractExpiredDate.format('YYYY-MM-DD HH:mm:ss')
            : null,
          productionDate: values.productionDate.format('YYYY-MM-DD HH:mm:ss'),
          saler: {
            ...salerInfo,
          },
          warningExpiredContractBefore: values.numberOfExpirationDate,
        },
      }
      this.updatePackage(key, data)
    })
  }

  _getSalerInfo(id) {
    const salerMatched = this.props.dataSource.find((item) => item._id === id)
    const result = _.pick(salerMatched, [
      '_id',
      'email',
      'firstName',
      'lastName',
      'phone',
      'username',
    ])
    return result
  }

  async updatePackage(key, data) {
    const res = await OrganizationApi.updateOne(key, data)
    if (res.data) {
      message.info('Update Package Organization success!')
      this.props.history.push(slug.organization.list)
    } else message.info(res.message)
  }

  render() {
    console.log('_isOnPremisesOrganization', this._isOnPremisesOrganization())
    const {
      form: { getFieldDecorator },
      lang: { t },
    } = this.props
    const userList = this.props.dataSource
    return (
      <Form onSubmit={this.handleSubmit}>
        <PageContainer>
          <Breadcrumb
            items={[
              'list',
              {
                id: 'rule',
                name: this.state.isLoaded ? this.state.nameOrganization : '',
              },
            ]}
          />

          {/*ROW 1*/}
          <Row gutter={24}>
            <Col span={8}>
              <FormItem label={t('organization.package.contractId.label')}>
                {getFieldDecorator(`contractId`, {
                  initialValue: this.state.packageInfo
                    ? this.state.packageInfo.contractId
                    : null,
                  rules: [
                    {
                      required: true,
                      message: t('organization.package.contractId.message'),
                    },
                  ],
                })(<Input style={{ margin: '-5px 0', width: '100%' }} />)}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label={t('organization.package.contractStatus.label')}>
                {getFieldDecorator(`contractStatus`, {
                  initialValue: this.state.packageInfo
                    ? this.state.packageInfo.contractStatus
                    : null,
                  rules: [
                    {
                      required: true,
                      message: t('organization.package.contractStatus.message'),
                    },
                  ],
                })(
                  <Select style={{ margin: '-5px 0', width: '100%' }}>
                    <Option value='PAID'>Đã thanh toán</Option>
                    <Option value='UNPAID'>Chưa thanh toán</Option>
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem
                label={t('organization.package.contractSignDate.label')}
              >
                {getFieldDecorator(`contractSignDate`, {
                  initialValue: this.state.packageInfo
                    ? moment(this.state.packageInfo.contractSignDate)
                    : null,
                  rules: [
                    {
                      required: true,
                      message: t(
                        'organization.package.contractSignDate.message'
                      ),
                    },
                  ],
                })(
                  <DatePicker
                    showTime
                    format='YYYY-MM-DD'
                    style={{ margin: '-5px 0', width: '100%' }}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          {/* *********************************************************************************** */}
          {/*ROW 2*/}
          <Row gutter={24}>
            <Col span={8}>
              <FormItem
                label={t('organization.package.contractExpiredDate.label')}
              >
                {this._isOnPremisesOrganization() ? (
                  <InputNumber
                    value='Unlimited'
                    disabled={this._isOnPremisesOrganization()}
                    style={{ margin: '-5px 0', width: '100%' }}
                  />
                ) : (
                  getFieldDecorator(`contractExpiredDate`, {
                    initialValue: this.state.packageInfo
                      ? moment(this.state.packageInfo.contractExpiredDate)
                      : null,
                    rules: [
                      {
                        required: true,
                        message: t(
                          'organization.package.contractExpiredDate.message'
                        ),
                      },
                    ],
                  })(
                    <DatePicker
                      showTime
                      disabled={this._isOnPremisesOrganization()}
                      format='YYYY-MM-DD'
                      style={{ margin: '-5px 0', width: '100%' }}
                    />
                  )
                )}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label={t('organization.package.productionDate.label')}>
                {getFieldDecorator(`productionDate`, {
                  initialValue: this.state.packageInfo
                    ? moment(this.state.packageInfo.productionDate)
                    : null,
                  rules: [
                    {
                      required: true,
                      message: t('organization.package.productionDate.message'),
                    },
                  ],
                })(
                  <DatePicker
                    showTime
                    format='YYYY-MM-DD'
                    style={{ margin: '-5px 0', width: '100%' }}
                  />
                )}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label={t('organization.package.directSeller.label')}>
                {getFieldDecorator(`directSeller`, {
                  initialValue: _.get(this.state, [
                    'packageInfo',
                    'saler',
                    '_id',
                  ]),
                  rules: [
                    {
                      required: true,
                      message: t('organization.package.directSeller.message'),
                    },
                  ],
                })(
                  <Select
                    defaultValue={_.get(this.state, [
                      'packageInfo',
                      'saler',
                      '_id',
                    ])}
                    showSearch
                    filterOption={(input, option) => {
                      // console.log(option.props.children)
                      return (
                        replaceVietnameseStr(option.props.children)
                          .toLowerCase()
                          .indexOf(replaceVietnameseStr(input).toLowerCase()) >= 0
                      )
                    }}
                    style={{ margin: '-5px 0', width: '100%' }}
                  >
                    {userList.map((user) => (
                      <Option key={user._id} value={user._id}>
                        {`${user.lastName} ${user.firstName} - ${user.email}` }
                        {/* <Flex> */}
                          {/* <Avatar size='small' src={user.avatar} /> */}
                          {/* <TextAvatar>
                          {`${user.lastName} ${user.firstName}` }
                          </TextAvatar> */}
                        {/* </Flex> */}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          {/* *********************************************************************************** */}
          {/*ROW 3*/}
          <Row gutter={24}>
            <Col span={8}>
              <FormItem label={t('organization.package.totalUser.label')}>
                {
                  // this._isOnPremisesOrganization()
                  //  ? (
                  //   <InputNumber
                  //     value='Unlimited'
                  //     disabled={this._isOnPremisesOrganization()}
                  //     style={{ margin: '-5px 0', width: '100%' }}
                  //   />
                  // )
                  // :
                  getFieldDecorator(`totalUser`, {
                    initialValue:
                      this.state.packageInfo && this.state.packageInfo.totalUser
                        ? this.state.packageInfo.totalUser
                        : this._isOnPremisesOrganization()
                        ? 500
                        : null,
                  })(
                    <InputNumber
                      // disabled={this._isOnPremisesOrganization()}
                      style={{ margin: '-5px 0', width: '100%' }}
                    />
                  )
                }
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label={t('organization.package.totalStation.label')}>
                {
                  // this._isOnPremisesOrganization()
                  // ?
                  // (
                  //   <InputNumber
                  //     value='Unlimited'
                  //     disabled={this._isOnPremisesOrganization()}
                  //     style={{ margin: '-5px 0', width: '100%' }}
                  //   />
                  // ) :
                  getFieldDecorator(`totalStation`, {
                    initialValue:
                      this.state.packageInfo &&
                      this.state.packageInfo.totalStation
                        ? this.state.packageInfo.totalStation
                        : this._isOnPremisesOrganization()
                        ? 500
                        : null,
                  })(
                    <InputNumber
                      // disabled={this._isOnPremisesOrganization()}
                      style={{ margin: '-5px 0', width: '100%' }}
                    />
                  )
                }
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem
                label={t('organization.package.numberOfExpirationDate.label')}
              >
                {this._isOnPremisesOrganization() ? (
                  <InputNumber
                    value='Unlimited'
                    disabled={this._isOnPremisesOrganization()}
                    style={{ margin: '-5px 0', width: '100%' }}
                  />
                ) : (
                  getFieldDecorator(`numberOfExpirationDate`, {
                    initialValue:
                      this.state.packageInfo &&
                      !this._isOnPremisesOrganization()
                        ? this.state.packageInfo.warningExpiredContractBefore
                        : numberOfExpirationDates[0].value,
                    rules: [
                      {
                        required: true,
                        message: t(
                          'organization.package.numberOfExpirationDate.message'
                        ),
                      },
                    ],
                  })(
                    <Select
                      disabled={this._isOnPremisesOrganization()}
                      style={{ margin: '-5px 0', width: '100%' }}
                    >
                      {numberOfExpirationDates.map((numberOfExpirationDate) => (
                        <Option value={numberOfExpirationDate.value}>
                          {t(`${numberOfExpirationDate.label}`)}
                        </Option>
                      ))}
                    </Select>
                  )
                )}
              </FormItem>
            </Col>
          </Row>
          <FormItem>
            <Button
              style={{ margin: '-5px 0', width: '100%' }}
              type='primary'
              htmlType='submit'
            >
              Save
            </Button>
          </FormItem>
        </PageContainer>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/organization/organization-package/index.js